<template>
  <div id="app">
    
        <el-row class="tac">
          <el-col :span="0">
            <el-menu
                default-active="1"
                class="menu-list"
            >
              <el-menu-item index="1">
                <el-icon><location /></el-icon>
                <span  ><router-link to="/autotest/productManager">产品管理</router-link></span>
              </el-menu-item>
              <el-menu-item index="2">
                <el-icon><icon-menu /></el-icon>
                <span><router-link to="/autotest/deviceManager">设备管理</router-link></span>
              </el-menu-item>
              <el-menu-item index="3" >
                <el-icon><document /></el-icon>
                <span ><router-link to="/autotest/testItemManager">用例管理</router-link></span>
              </el-menu-item>
              <el-menu-item index="4">
                <el-icon><setting /></el-icon>
                <span ><router-link to="/autotest/testItemAction">执行测试</router-link></span>
              </el-menu-item>
              <el-menu-item index="5">
                <span ><router-link to="/shici" class="el-button el-button-info toshici">诗词</router-link></span>
              </el-menu-item>
              <el-menu-item index="7">
                <span ><router-link to="/shicigame" class="el-button el-button-info toshici">诗词游戏</router-link></span>
              </el-menu-item>
              <el-menu-item index="8">
                <span ><router-link to="/shicifetch" class="el-button el-button-info toshici">诗词抓取</router-link></span>
              </el-menu-item>
              <el-menu-item index="9">
                <span><router-link to="/login" class="el-button el-button-info toshici">登录</router-link></span>
              </el-menu-item>
              <el-menu-item v-if="isAdmin" index="10">
                <span><router-link to="/manager" class="el-button el-button-info toshici">后台管理</router-link></span>
              </el-menu-item>
              <el-menu-item v-if="isLoggedIn" index="11">
                <span><a href="javascript:void(0)" class="el-button el-button-info toshici" @click="logout">退出登录</a></span>
              </el-menu-item>
              <el-menu-item index="12">
                <span><router-link to="/biji" class="el-button el-button-info toshici">笔记</router-link></span>
              </el-menu-item>
              <el-menu-item v-if="isAdmin" index="13">
                <span><router-link to="/bijimng" class="el-button el-button-info toshici">笔记管理</router-link></span>
              </el-menu-item>
              <el-menu-item index="6">
                <span ><router-link to="/debug_yqsl" class="el-button el-button-info ">调试</router-link></span>
              </el-menu-item>
              <el-menu-item index="6">
                <span ><router-link to="/feitian/feitian" class="el-button el-button-info ">飞天</router-link></span>
              </el-menu-item>
            </el-menu>
          </el-col>

          <el-col >

          <router-view></router-view>

          </el-col>

        </el-row>

      <el-footer>
        <div class="page-bottom">
          @2019-2026 ICP证：<el-link href="http://beian.miit.gov.cn/" >粤ICP备2026017370号-1</el-link>
        </div>
      </el-footer>
    <div>

    </div>
    <el-divider></el-divider>

  </div>
</template>

<script>
export default {
  data() {
    return {
      "eachData":[],
      me: {},
      tokenExists: false
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.tokenExists
    },
    isAdmin() {
      return String(this.me?.role || '') === 'admin'
    }
  },
  methods: {
    refreshMe() {
      try {
        this.me = JSON.parse(localStorage.getItem('shicigame_user') || '{}') || {}
        this.tokenExists = !!localStorage.getItem('shicigame_token')
      } catch (e) {
        this.me = {}
        this.tokenExists = false
      }
    },
    logout() {
      try {
        localStorage.removeItem('shicigame_token')
        localStorage.removeItem('shicigame_user')
      } catch (e) {
      }
      this.refreshMe()
      window.dispatchEvent(new Event('shicigame-auth-changed'))
      this.$router.push('/login')
    }
  },
  mounted() {
    this.refreshMe()
    window.addEventListener('shicigame-auth-changed', this.refreshMe, false)
    window.addEventListener('hashchange',()=>{
      var currentPath = window.location.hash.slice(1);
      console.log("path: ", currentPath);
      if (this.$router.path !== currentPath) {
        this.$router.push(currentPath);
      }
    }, false)
  }
}
</script>

<style>
/* html/body 同步铺宣纸，避免浏览器默认白底从 #app 边缘露出 */
html,
body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  background-color: #f5f1e5;
  background-image:
    radial-gradient(900px 420px at 10% -10%, rgba(255, 252, 240, 0.65), transparent 55%),
    radial-gradient(800px 380px at 100% 0%, rgba(233, 224, 200, 0.55), transparent 55%),
    repeating-linear-gradient(0deg, rgba(153, 145, 127, 0.03) 0 1px, transparent 1px 9px),
    repeating-linear-gradient(90deg, rgba(153, 145, 127, 0.025) 0 1px, transparent 1px 13px);
}

#app {
  font-family: Helvetica, sans-serif;
  /*text-align: center;*/
  min-height: 100vh;
  background-color: transparent;
}
.toshici {
  background-color: #66b1ff;
  color:black;
}
#app a {
}
.page-bottom {
  margin-top: 2em;
  font-size: 90%;
  color: gray;
  text-align: center;
}


.title-icon {
  font-size: 28px;
  margin-right: 12px;
  opacity: 0.95;
}

.title-text {
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 3px;
}

.title-sub {
  margin-left: auto;
  font-size: 13px;
  opacity: 0.8;
  font-weight: 400;
  letter-spacing: 1px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
}
.menu-list {
  background-color: #e0e3e3;
}
a {
  text-decoration: none;
}
</style>
